<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-layout row wrap>
                <v-btn style="margin:0 10px 10px 12px;" @click="customFilter(0)" :color="activeType == 0 ? '#a77800' : '#646262'" dark>
                    Khách hàng
                </v-btn>
                <v-btn style="margin-right: 10px;" @click="customFilter(1)" :color="activeType == 1 ? '#a77800' : '#646262'" dark>
                    Nội bộ
                </v-btn>
                </v-layout>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr :id="'r-' + item.ID">
                            <td>{{ item.ID }}</td>
                            <td>{{ activeType ? item.CreatedBy : item.Username }}</td>
                            <td v-if="!activeType">{{ item.CSName }}</td>
                            <td v-bind:style="{ 'color': get_status_color(item.Status, payservice_statuslist)}">{{ item.Status | display_value(payservice_statuslist) }}</td>
                            <td>{{ item.Type | display_value(payservice_typelist) }}</td>
                            <td>{{ item.PayType | display_value(paytype_list) }}</td>
                            <td class="text-end">{{ item.ExchangeRate | currency}}</td>
                            <td class="text-end">{{ item.Amount | currency('¥', 1)}}</td>
                            <td class="text-end">{{ item.FeeAmount | currency('', 0)}}</td>
                            <td>{{ item.CreatedDate | display_date }}</td>
                            <td class="text-center">
                                <v-icon medium class="mr-2" @click="gotoDetail(item.ID)">fa-edit</v-icon>
                                <!-- <v-icon v-bind:style="{ 'visibility': item.Status == 3 || item.Status == 4 ? 'visible' : 'hidden'}" medium class="mr-2" @click="payItem(item)">fa-credit-card</v-icon> -->
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog v-model="dialogNew" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="title">Tạo mới đơn hàng</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
                <v-flex lg2 md2 sm12>
                    <p>Loại đơn</p>
                </v-flex>
                <v-flex lg3 md3 sm6>
                    <label><input type="radio" v-model="newOrder.Type" value="0"> Khách hàng</label>
                </v-flex>
                <v-flex lg3 md3 sm6>
                    <label><input type="radio" v-model="newOrder.Type" value="1"> Nội bộ</label>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex v-if="newOrder.Type ==  0" lg8 md8 sm12>
                <v-autocomplete label="Khách hàng" v-model="newOrder.UID" :items="customers" item-text="Username" item-value="ID" ></v-autocomplete>
              </v-flex>
              <v-flex lg8 md8 sm12 v-if="newOrder.Type == 0">
                <v-checkbox label="Fix tỷ giá" v-model="newOrder.FixPrice"></v-checkbox>
              </v-flex>
              <v-flex lg8 md8 sm12 v-if="newOrder.Type == 0 && newOrder.FixPrice">
                <h-currency-input v-model="newOrder.ExchangeRate" :decimal="0" label="Tỷ giá (₫)"></h-currency-input>
              </v-flex>
              <v-flex lg8 md8 sm12>
                <h-currency-input v-model="newOrder.Amount" :decimal="1" label="Số tiền thanh toán hộ (¥)"></h-currency-input>
              </v-flex>
              <v-flex lg8 md8 sm12 v-if="newOrder.Type == 0">
                <v-select v-model="newOrder.PayType" :items="paytype_list" item-text="name" item-value="value" label="Hình thức thanh toán" class="input-group--focused"></v-select>
              </v-flex>
              <v-flex v-if="newOrder.Type == 1" lg8 md8 sm12>
                <v-text-field v-model="newOrder.OrderCode" label="Mã đơn TQ" @change="checkRealAmount"></v-text-field>
              </v-flex>
              <v-flex lg8 md8 sm12>
                <h-currency-input v-if="newOrder.Type == 0 && newOrder.FixPrice" v-model="newOrder.FeeAmount" :decimal="0" label="Phí thanh toán (đ)"></h-currency-input>
              </v-flex>
              <v-flex lg8 md8 sm12>
                <v-text-field v-model="newOrder.BankName" label="Ngân hàng người nhận"></v-text-field>
              </v-flex>
              <v-flex lg8 md8 sm12>
                <v-text-field v-model="newOrder.BankAccountName" label="Họ tên người nhận"></v-text-field>
              </v-flex>
              <v-flex lg8 md8 sm12>
                <v-text-field v-model="newOrder.BankAccountNumber" label="Tài khoản người nhận"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogNew = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="createNewOrder">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice, sendSuccessNotice } from "@/commons/utils";
import { request_detail } from "@/commons/hpod";
import _ from "lodash";
import Vue from 'vue';

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            payservice_statuslist: configs.PAY_SERVICE_STATUS,
            payservice_typelist: configs.PAY_SERVICE_TYPE,
            paytype_list: configs.PAY_SERVICE_PAYTYPE,
            payserviceStatusEnum: configs.PAY_SERVICE_STATUS_ENUM,
            viewName: "payservice_list",
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            dialogNew: false,
            newOrder: {
                UID: 0,
                ExchangeRate: 0,
                Status: 3,
                Type: 0,
                FixPrice: false,
                PayType: ''
            },
            activeType: 0
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.payservice.all.data,
            total_rows: state => state.payservice.all.total,
            loading: state => state.payservice.loading,
            customers: state => state.customer.master.data
        }), 
        headers() {
            let dataType = configs.DATA_TYPE;
            let tmp = [
                    {
                        text: "ID",
                        value: "ID",                   
                        dataType: dataType["Number"]
                    },
                    {
                        text: this.activeType ? "Người tạo" : "Khách hàng",
                        value: this.activeType ? "CreatedBy" : "Username",
                        filterable: true,
                        dataType: dataType["String"]
                    },
                    {
                        text: "Trạng thái",
                        value: "Status",
                        filterable: true,
                        values: configs.PAY_SERVICE_STATUS,
                        dataType: dataType["Enum"]
                    },
                    {
                        text: "Loại đơn",
                        value: "Type",
                        filterable: true,
                        values: configs.PAY_SERVICE_TYPE,
                        dataType: dataType["Enum"]
                    }, 
                    {
                        text: "Phân loại",
                        value: "PayType",
                        filterable: true,
                        values: configs.PAY_SERVICE_PAYTYPE,
                        dataType: dataType["Enum"]
                    },
                    {
                        text: "Tỷ giá",
                        value: "ExchangeRate",
                        align: "end",
                        filterable: true,
                        dataType: dataType["Number"]
                    },
                    {
                        text: "Số tiền",
                        value: "Amount",
                        align: "end",
                        filterable: true,
                        dataType: dataType["Number"]
                    },
                    {
                        text: "Phí thanh toán",
                        value: "FeeAmount",
                        align: "end",
                        filterable: true,
                        dataType: dataType["Number"]
                    },
                    {
                        text: "Ngày tạo",
                        value: "CreatedDate",
                        filterable: true,
                        dataType: dataType["Date"]
                    },
                    {
                        text: "Thao tác",
                        value: "",
                        align: "center",
                        sortable: false,
                        filterable: false
                    }
                ];
            if(!this.activeType) {
                tmp.splice(2, 0 , {
                    text: "Phụ trách",
                    value: "CSName",
                    filterable: true,
                    dataType: dataType["String"]
                })
            }
            return tmp;
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            const clearFilter = param.filter.filter(f => f.column  != 'Type');
            clearFilter.push({ column: 'Type', condition: 'in', value: [this.activeType] });
            param.filter = clearFilter;
            this.$store.dispatch("payservice/getList", param);
            this.getCustomerList();
        },
        payItem(payItem) {
            let request = {
                Status: 5,
                UID: payItem.UID,
                Type: payItem.Type
            };
            if(payItem.Status == 3) {
                request.Payment = payItem.TotalAmount;
            }
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("payservice/setDetail", {
                data: request,
                id: payItem.ID,
                params: param
            });
        },
        gotoDetail: function (id) {
            let routeData = this.$router.resolve({
                name: "PayServiceDetail",
                params: {
                    Pid: id,
                    title: `Chi tiết (#${id})`
                }
            });
            window.open(routeData.href, "_blank");
        },
        deleteItem: function(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        customFilter(type) {
            this.activeType = type;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        getCustomerList() {
            this.$store.dispatch("customer/getCustomerList", {
                is_master: 1,
                fields: ["ID", "Username"]
            });
        },
        createData() {
            this.newOrder.Type = this.activeType;
            this.dialogNew = true;
        },
        createNewOrder() {
            if(this.newOrder.UID == 0 && this.newOrder.Type == 0) {
                sendErrorNotice("Hãy chọn khách hàng!");
                return;
            }
            if(this.newOrder.Type == 0 && this.newOrder.PayType == "" && !this.newOrder.FixPrice) {
                sendErrorNotice("Hãy chọn hình thức thanh toán!");
                return;
            }
            if (this.newOrder.Type == 1 && this.newOrder.TotalRealAmountCNY != this.newOrder.Amount) {
                sendErrorNotice("Giá trị lệnh không khớp với giá trị thật của đơn hàng!");
                return;
            }
            if (this.newOrder.Type == 0) {
                const cust = _.find(this.customers, {'ID': this.newOrder.UID});
                this.newOrder.Username = cust.Username;
            }
            delete this.newOrder.TotalRealAmountCNY;
            this.$store.dispatch("payservice/setDetail", {data: this.newOrder, id: 0});
            this.dialogNew = false;
            this.newOrder = {
                UID: 0,
                Status: 3,
                Type: 0,
                FixPrice: false,
                PayType: ''
            };
        },
        checkRealAmount() {
            request_detail('main_order/ordercode', data => {
                if(data.status == 200 && _.size(data.data) > 0) {
                    const order = data.data;
                    this.newOrder.TotalRealAmountCNY = order.RealAmount;
                    if(order.PayID > 0) {
                        sendErrorNotice("Mã đơn TQ đã được thanh toán.");
                        return;
                    }
                    if(!order.RealAmount) {
                        sendErrorNotice("Đơn hàng chưa nhập giá tiền mua thật.");
                    }
                    else if (this.newOrder.TotalRealAmountCNY != this.newOrder.Amount) {
                        sendErrorNotice("Giá trị lệnh không khớp với giá trị thật của đơn hàng!");
                    }
                } else {
                    sendErrorNotice('Mã đơn hàng không tồn tại.')
                }              
            }, Vue.http, '', this.$store.state.authentication.token, {'ordercode': this.newOrder.OrderCode});
        },
        onExport: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            const clearFilter = param.filter.filter(f => f.column  != 'Type');
            clearFilter.push({ column: 'Type', condition: 'in', value: [this.activeType] });
            param.filter = clearFilter;
            this.$store.dispatch("payservice/exportList", param);
        },
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_OTHER_ACTION", this.onExport);
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("payservice/removeDetail", id);
            setTimeout(this.filter_data, 200);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_OTHER_ACTION", this.onExport);
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
